import { ContainerModule } from 'inversify';
import { PlayerModuleSymbol } from '../api';
import { CourseCompletionPlayerModule } from './course-completion-player-module';
import { courseCompletionServiceModule } from './service/di'

const courseCompletionModule = new ContainerModule((bind) => {
  // player module
  bind(PlayerModuleSymbol).to(CourseCompletionPlayerModule)
});

export const courseCompletionModules = [
  courseCompletionModule,
  courseCompletionServiceModule
]
